import React from 'react';
import { useQuery } from 'react-query';
import api from '../../services/api';
import { Package, Plus } from 'lucide-react';

const Produtos = () => {
  const { data, isLoading } = useQuery(
    'produtos',
    async () => {
      const response = await api.get('/api/produtos');
      return response.data.data.produtos;
    }
  );

  if (isLoading) {
    return <div className="loading">Carregando...</div>;
  }

  return (
    <div>
      <div className="page-header">
        <h2>Produtos</h2>
        <button className="btn btn-primary">
          <Plus size={20} />
          Novo Produto
        </button>
      </div>

      <div className="card">
        <table style={{ width: '100%' }}>
          <thead>
            <tr>
              <th>Nome</th>
              <th>Categoria</th>
              <th>Preço</th>
              <th>Estoque</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {data?.map((produto) => (
              <tr key={produto._id}>
                <td>{produto.nome}</td>
                <td>{produto.categoria}</td>
                <td>R$ {produto.preco?.toFixed(2)}</td>
                <td>{produto.estoque?.quantidade || 0}</td>
                <td>
                  <span className={produto.disponivel ? 'status-active' : 'status-inactive'}>
                    {produto.disponivel ? 'Disponível' : 'Indisponível'}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Produtos;

